import React from "react";
import Formelemenets from "./Formelemenets";
import { Controller, useForm } from "react-hook-form";

const Supportform = () => {
  const {
    control,
    // handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValue: {
      name: "",
      email: "",
      message: "",
    },
  });
  return (
    <>
      <div className=" mx-auto mb-32 bg-gradient-to-t from-white from-10% via-white via-10% to-[#59A94F] to-90% pb-8 ">
        <div className="flex justify-center ">
          <h1
            className=" p-4 mb-6 leading-normal font-display text-3xl lg:text-6xl font-extrabold"
            data-aos="fade-up"
          >
            Ask Your Questions
          </h1>
        </div>
        <div className="px-4 sm:w-2/3 lg:w-2/3 mx-auto">
          <div className="rounded-lg shadow-xl bg-white py-10 md:py-12 px-4 md:px">
            <form>
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Formelemenets
                    type="text"
                    label="Name"
                    placeholder="Enter your Name..."
                    fieldRef={field}
                    hasError={errors.naem?.type === "required"}
                  />
                )}
              />

              <Controller
                name="Email"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Formelemenets
                    type="text"
                    label="Email"
                    placeholder="Enter your Email..."
                    fieldRef={field}
                    hasError={errors.naem?.type === "required"}
                  />
                )}
              />

              <Controller
                name="Phone No."
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Formelemenets
                    type="text"
                    label="Phone No."
                    placeholder="Eg. 989658875"
                    fieldRef={field}
                    hasError={errors.naem?.type === "required"}
                  />
                )}
              />

              <Controller
                name="Subject"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Formelemenets
                    type="text"
                    label="Subject"
                    placeholder="Name the Subject"
                    fieldRef={field}
                    hasError={errors.naem?.type === "required"}
                  />
                )}
              />

              <Controller
                name="Query"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Formelemenets
                    type="textarea"
                    label="Query"
                    placeholder="Enter your Query..."
                    fieldRef={field}
                    hasError={errors.naem?.type === "required"}
                  />
                )}
              />

              <button className=" 3/4 mt-3 rounded-md  py-2 px-5 text-white bg-cyan-700 hover:bg-white hover:text-cyan-700  hover:border-black  ">
                submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Supportform;
